import React from 'react';

export default () => <div style={{width: "100%", height: "100%", position: "fixed", top: 0, left: 0, zIndex: 99999999, backgroundColor: "#fff"}}/>;
